export default {
	id: 'SIMPLE_PREMIUM_FALLBACK_12W_79_12W_15_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_12w_79_12w_15_99_usd',
			EUR: 'simple_premium_12w_69_12w_15_99_eur',
			GBP: 'simple_premium_12w_79_12w_15_99_gbp',
			AUD: 'simple_premium_12w_129_12w_23_99_aud',
			CAD: 'simple_premium_12w_129_12w_23_99_cad',
			DKK: 'simple_premium_12w_599_12w_119_2_dkk',
			SEK: 'simple_premium_12w_920_12w_183_2_sek',
			NOK: 'simple_premium_12w_920_12w_183_2_nok',
			BRL: 'simple_premium_12w_179_12w_55_2_brl',
			MXN: 'simple_premium_12w_1299_12w_263_2_mxn',
			TRY: 'simple_premium_12w_2599_12w_532_8_try',
			ARS: 'simple_premium_12w_104990_12w_21592_ars',
			COP: 'simple_premium_12w_319990_12w_64792_cop',
			CLP: 'simple_premium_12w_75990_12w_15992_clp',
		},
		primer: 'prd_Lpfn2tzW6yA3',
	},
}
